import http from '@services/http'

export default {
  // 期刊信息
  getSubscribeJournalList(data?: object): Promise<any> {
    return http.get('user-api/subscribe/journal/list', data || {})
  },

  // 获取学者的订阅信息
  getSubscribeList(data?: object): Promise<any> {
    return http.get('user-api/subscribe/list', data || {})
  }
}
